import { Link } from 'react-router-dom';
import type { FC } from 'react';
import { Container, LogoImgBox, Text, Title } from './ErrorContainer.styled';
import { ReactComponent as LogoWhiteSVG } from './images/logo-white.svg';

interface Props {
  title: string;
  text: string;
  homeLinkButton?: boolean;
  forceHideHomeLink?: boolean;
  disableLogoLink?: boolean;
}

const ErrorContainer: FC<Props> = ({
  title,
  text,
  homeLinkButton = true,
  forceHideHomeLink = false,
  disableLogoLink = false,
}) => {
  const shouldShowHomeLink = homeLinkButton && !forceHideHomeLink;

  return (
    <Container>
      <Title>{title}</Title>
      <Text>{text}</Text>
      {shouldShowHomeLink && <Link to='/'>Вернуться на главную</Link>}

      <LogoImgBox
        style={
          disableLogoLink
            ? { pointerEvents: 'none', cursor: 'default' }
            : undefined
        }
      >
        <LogoWhiteSVG />
      </LogoImgBox>
    </Container>
  );
};

export default ErrorContainer;
